import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ROUTE_TRANSITION } from '../../../app.animation';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'vr-action-plans',
  templateUrl: './action-plans.component.html',
  styleUrls: ['./action-plans.component.scss'],
  animations: [...ROUTE_TRANSITION],
  host: { '[@routeTransition]': '' }
})
export class ActionPlanComponent implements OnInit {
  isLoading = false;
  auditError: string = null;

  loginForm: FormGroup;
  auditId = new FormControl('', Validators.required);
  planActionCode = new FormControl('', Validators.required);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private changeDetectorRefs: ChangeDetectorRef
  ) {
    this.loginForm = new FormGroup({
      audit_id: this.auditId,
      plan_action_code: this.planActionCode
    });
  }

  ngOnInit() {
    const auditId = this.route.snapshot.queryParamMap.get('audit_id');
    const code = this.route.snapshot.queryParamMap.get('code');

    if (auditId && code) {
      this.auditId.setValue(auditId);
      this.planActionCode.setValue(code);
      this.submitForm();
    }
  }

  submitForm() {
    this.auditError = null;
    this.isLoading = true;
    this.http.post(environment.API_PATH + 'auth/loginplanaction', { user: this.loginForm.value }, { withCredentials: true }).subscribe(response => {
      this.isLoading = false;
      if (response['success']) {
        const auditId = this.auditId.value;
        this.router.navigate(['/actions/plans'], { queryParams: { search: auditId } });
      } else {
        const errors = response['errors'] || {};
        if (errors['general'] === 'INVALID_CREDENTIALS') {
          this.auditError = 'Numéro d\'audit ou code d\'accès invalide.';
        } else if (errors['general'] === 'EMPTY_REQUEST') {
          this.auditError = 'Requête invalide.';
        } else if (errors['audit_id']) {
          this.auditError = 'Veuillez saisir un numéro d\'audit valide.';
        } else if (errors['plan_action_code']) {
          this.auditError = 'Veuillez saisir votre code d\'accès.';
        } else {
          this.auditError = 'Audit non trouvé ou non disponible.';
        }
        this.changeDetectorRefs.detectChanges();
      }
    }, () => {
      this.isLoading = false;
      this.auditError = 'Une erreur est survenue, veuillez réessayer.';
      this.changeDetectorRefs.detectChanges();
    });
  }
}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/pages/auth/action-plans/action-plans.component.ts